import React from 'react';
import {INodeTemplateProps} from '@techsee/techsee-ui-common/lib/simple-tree-control-view';
import {RESOURCE_TYPES} from '../../../../../../states/dashboard/main/main.settings';
import find from 'lodash/find';
import {observer} from 'mobx-react';

const getTypeIcon = (type: string): string => {
    const resourceType = find(RESOURCE_TYPES, {type: type.toUpperCase()});
    return resourceType ? resourceType.icon : '';
};

export const PredefinedTreeTemplate: React.FC<INodeTemplateProps> = observer(({node}) => {
    const isTopLevel = node.data.type === 'dir' && node.parents.length === 0;
    const isEntry = node.data.type !== 'dir';

    return (
        <span title={node.data.title} className={isTopLevel ? 'predefined-header' : isEntry ? 'predefined-entry' : ''}>
            {isEntry && node.data.type && <i className={getTypeIcon(node.data.type)} style={{marginRight: '5px'}}></i>}
            {node.data.title}
        </span>
    );
});
